import React from "react";
import MdaeButton from "../../common_widgets/button";
export const codeValueTemplate = (e) => (
  <CellComponent>
    {e.data?.codeValue + " - " + (e.data?.codeDesc || "")}
  </CellComponent>
);
const cptHcpsTemplate = (e) => {
  return (
    <div>
      {e.data?.cptHcpcs && (
        <CellComponent>
          {e.data?.cptHcpcs + " - " + (e.data?.cptHcpcsDesc || "")}
        </CellComponent>
      )}
    </div>
  );
};

export const getLinesProfessionalExtraColumns = (aliasBillDataFields) => [
    {
        dataField: "nationalDrugCode",
        caption: "NDC",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "nationalDrugCodeCellTemplate",
        alignment: "center",
        width: 80,
    },
    {
        dataField: "nationalDrugQuantity",
        caption: "NDC Units",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "nationalDrugQuantityCellTemplate",
        alignment: "center",
        width: 80,
    },
    {
        dataField: "ndcRxNo",
        caption: "NDC Rx",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "ndcRxNoCellTemplate",
        alignment: "center",
        width: 80,
    },
    {
        dataField: "nationalDrugUOM",
        caption: "NDC Unit Qualifier",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "nationalDrugUOMCellTemplate",
        alignment: "center",
        width: 100,
    },
    {
        dataField: "coder",
        caption: "Coder",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "coderCellTemplate",
        alignment: "center",
        width: 100,
    },
    {
        dataField: "billData1Name",
        caption: aliasBillDataFields.lineBillData1,
        allowFiltering: false,
        allowHeaderFiltering: false,
        alignment: "center",
        width: 100,
        headerCellTemplate: function (container, options) {
            const alias = aliasBillDataFields.billData1AliasName;
            const displayName = aliasBillDataFields.lineBillData1;

            container.textContent = displayName;
            container.title = alias;        }
    },
    {
        dataField: "billData2Name",
        caption: aliasBillDataFields.lineBillData2,
        allowFiltering: false,
        allowHeaderFiltering: false,
        alignment: "center",
        width: 100,
        headerCellTemplate: function (container, options) {
            const alias = aliasBillDataFields.billData2AliasName;
            const displayName = aliasBillDataFields.lineBillData2;

            container.textContent = displayName;
            container.title = alias;        }
    },
    {
        dataField: "billData3Name",
        caption: aliasBillDataFields.lineBillData3,
        allowFiltering: false,
        allowHeaderFiltering: false,
        alignment: "center",
        width: 100,
        headerCellTemplate: function (container, options) {
            const alias = aliasBillDataFields.billData3AliasName;
            const displayName = aliasBillDataFields.lineBillData3;

            container.textContent = displayName;
            container.title = alias;        }
    },
];

export const getlinesInOutExtraColumns = (aliasBillDataFields) => [
        {
            dataField: "nationalDrugCode",
            caption: "NDC",
            allowFiltering: false,
            allowHeaderFiltering: false,
            // cellTemplate: "nationalDrugCodeCellTemplate",
            alignment: "center",
            width: 80,
        },
        {
            dataField: "nationalDrugQuantity",
            caption: "NDC Units",
            allowFiltering: false,
            allowHeaderFiltering: false,
            // cellTemplate: "nationalDrugQuantityCellTemplate",
            alignment: "center",
            width: 80,
        },
        {
            dataField: "ndcRxNo",
            caption: "NDC Rx",
            allowFiltering: false,
            allowHeaderFiltering: false,
            // cellTemplate: "ndcRxNoCellTemplate",
            alignment: "center",
            width: 80,
        },
        {
            dataField: "nationalDrugUOM",
            caption: "NDC Unit Qualifier",
            allowFiltering: false,
            allowHeaderFiltering: false,
            // cellTemplate: "nationalDrugUOMCellTemplate",
            alignment: "center",
            width: 100,
        },
        {
            dataField: "coder",
            caption: "Coder",
            allowFiltering: false,
            allowHeaderFiltering: false,
            // cellTemplate: "coderCellTemplate",
            alignment: "center",
            width: 100,
        },
        {
          dataField: "billData1Name",
          caption: aliasBillDataFields.lineBillData1,
          allowFiltering: false,
          allowHeaderFiltering: false,
          alignment: "center",
          width: 100,
            headerCellTemplate: function (container, options) {
                const alias = aliasBillDataFields.billData1AliasName;
                const displayName = aliasBillDataFields.lineBillData1;

                container.textContent = displayName;
                container.title = alias;            }
        },
        {
          dataField: "billData2Name",
          caption: aliasBillDataFields.lineBillData2,
          allowFiltering: false,
          allowHeaderFiltering: false,
          alignment: "center",
            width: 100,
            headerCellTemplate: function (container, options) {
                const alias = aliasBillDataFields.billData2AliasName;
                const displayName = aliasBillDataFields.lineBillData2;

                container.textContent = displayName;
                container.title = alias;            }
        },
        {
          dataField: "billData3Name",
          caption: aliasBillDataFields.lineBillData3,
          allowFiltering: false,
          allowHeaderFiltering: false,
          alignment: "center",
            width: 100,
            headerCellTemplate: function (container, options) {
                const alias = aliasBillDataFields.billData3AliasName;
                const displayName = aliasBillDataFields.lineBillData3;

                container.textContent = displayName;
                container.title = alias;            }
        },
  ]

const serviceUnitsTemplate = (e) => {
  const unitMap = {
    UN: "Units",
    MJ: "Minutes",
    DA: "Days",
  };

  const unitLabel = unitMap[e.data?.unitOfMeasurement] || e.data?.unitOfMeasurement || "";
  return (
    <div>
      {e.data?.serviceUnits && (
        <div title={`${e.data.serviceUnits} - ${unitLabel}`}>
          {e.data?.serviceUnits}
        </div>
      )}
    </div>
  );
};

export const diagnosisConfigs = {
  Professional: {
    List: [
      {
        dataField: "codePositionNo",
        caption: "",
        cellRender: (e) => (
          <CellComponent>{e.data.codePositionNoForView}</CellComponent>
        ),
        width: 40,
      },
      {
        caption: "Code",
        dataField: "codeValue",
        allowFiltering: false,
        allowHeaderFiltering: false,
        cellRender: codeValueTemplate,
        width: 450,
      },
    ],
  },
  OutPatient: {
    List: [
      {
        dataField: "codePositionNo",
        caption: "",
        cellRender: (e) => (
          <CellComponent>{e.data.codePositionNoForView}</CellComponent>
        ),
        width: 40,
      },
      {
        dataField: "codeValue",
        allowFiltering: false,
        allowHeaderFiltering: false,
        caption: "Code",
        cellRender: codeValueTemplate,
        width: 450,
      },
      {
        dataField: "poaInd",
        caption: "POA",
        allowFiltering: false,
        allowHeaderFiltering: false,
        width: 118,
        alignment: "center",
      },
    ],
  },
  InPatient: {
    List: [
      {
        dataField: "codePositionNo",
        caption: "",
        cellRender: (e) => (
          <CellComponent>{e.data.codePositionNoForView}</CellComponent>
        ),
        width: 40,
      },
      {
        dataField: "codeValue",
        allowFiltering: false,
        allowHeaderFiltering: false,
        caption: "Code",
        cellRender: codeValueTemplate,
        width: 450,
      },
      {
        dataField: "poaInd",
        caption: "POA",
        allowFiltering: false,
        allowHeaderFiltering: false,
        width: 118,
        alignment: "center",
      },
    ],
  },
};
export const cptHcpcsCellHeaderTemplate = (e) => (
  <div>
    CPT<sup>®</sup>/HCPCS
  </div>
);
export const CellComponent = (props) => (
  <div className="text-overflow-ellipsis" title={props.children}>
    {props.children}
  </div>
);

export const linesConfig = {
  Current: {
    Columns: [],
  },
  InOutPatient: {
    paging: {
      pageSize: 10,
    },
    searchPanel: {
      visible: false,
    },
    pager: {
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 30],
      showInfo: true,
    },
    Columns: [
      {
        fixed: true,
        allowSorting: false,
        allowFiltering: false,
        allowGrouping: false,
        allowResizing: false,
        allowReordering: false,
        allowHiding: false,
        allowExporting: false,
        alignment: "center",
        dataField: "caseLineId",
        caption: "",
        visible: true,
        cellRender: (e) => {
          return (
            <div
              className={
                "line-denial-flag-icon case-line-assigned-to-no" +
                e.data.caseLineId
              }
            >
              <div>
                <MdaeButton
                  stylingMode="text"
                  role="dxButton"
                  id="btnLineDenialFlag"
                  icon={
                    "/images/ui-rewrite-icons/menuicons/denialspredictorlineflagicon.svg"
                  }
                />
              </div>
            </div>
          );
        },
        width: 45,
      },
      {
        dataField: "caseLineAssignedNo",
        caption: "",
        // cellTemplate: "caseLineAssignedNoCellTemplate",
        fixed: true,
        width: 50,
      },
      {
        dataField: "revenueCode",
        caption: "Rev Code",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "revenueCodeCellTemplate",
        fixed: true,
        alignment: "center",
        width: 100,
      },
      {
        dataField: "cptHcpcs",
        headerCellRender: cptHcpcsCellHeaderTemplate,
        // headerCellTemplate: "cptHcpcsCellHeaderTemplate",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "cptHcpcsCellTemplate",
        cellRender: cptHcpsTemplate,
        fixed: true,
        alignment: "left",
        width: 200,
      },
      {
        dataField: "procedureModifier1",
        caption: "Mod",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "procedureModifier1CellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "procedureModifier2",
        caption: "Mod",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "procedureModifier2CellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "procedureModifier3",
        caption: "Mod",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "procedureModifier3CellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "procedureModifier4",
        caption: "Mod",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "procedureModifier4CellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "fromServiceDate",
        caption: "Serv Date",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "fromServiceDateCellTemplate",
        fixed: true,
        alignment: "center",
        width: 80,
      },
      {
        dataField: "serviceUnits",
        caption: "Units",
        allowFiltering: false,
        allowHeaderFiltering: false,
        cellRender: serviceUnitsTemplate,
        // cellTemplate: "unitOfMeasurementCellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "totalChargeAmount",
        caption: "Charges",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "totalChargeAmountCellTemplate",
        fixed: true,
        alignment: "right",
        dataType: "number",
        width: 115,
      },
      {
        dataField: "nonCoveredChargedAmt",
        caption: "Non-Covered Chg",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "nonCoveredChargedAmtCellTemplate",
        cellRender: (e) => (
          <div>
            {e.data.nonCoveredChargedAmt != null && (
              <CellComponent>${e.data.nonCoveredChargedAmt} </CellComponent>
            )}
          </div>
        ),
        alignment: "right",
        width: 115,
      },
      {
        dataField: "originalPaymentAmtDecimal",
        caption: "Original Pmt",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "originalPaymentCellTemplate",
        cellRender: (e) => (
          <div>
            {e.data.originalPaymentAmt != null && (
              <CellComponent>${e.data.originalPaymentAmt} </CellComponent>
            )}
          </div>
        ),
        alignment: "right",
        width: 115,
      },
      {
        dataField: "financialImpact",
        caption: "Fin Impact",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "financialImpactCellTemplate",
        cellRender: (e) => (
          <CellComponent>{e.data.financialImpactAmtForView}</CellComponent>
        ),
        alignment: "center",
        width: 115,
      },
    ],
  },
  Professional: {
    Columns: [
      {
        fixed: true,
        allowSorting: false,
        allowFiltering: false,
        allowGrouping: false,
        allowResizing: false,
        allowReordering: false,
        allowHiding: false,
        allowExporting: false,
        alignment: "center",
        dataField: "caseLineId",
        caption: "",
        visible: true,
        cellRender: (e) => {
          return (
            <div
              className={
                "line-denial-flag-icon case-line-assigned-to-no" +
                e.data.caseLineId
              }
            >
              <div>
                <MdaeButton
                  stylingMode="text"
                  role="dxButton"
                  id="btnLineDenialFlag"
                  icon={
                    "/images/ui-rewrite-icons/menuicons/denialspredictorlineflagicon.svg"
                  }
                />
              </div>
            </div>
          );
        },
        width: 45,
      },
      {
        dataField: "caseLineAssignedNo",
        caption: "",
        fixed: true,
        width: 40,
      },
      {
        dataField: "cptHcpcs",
        // headerCellTemplate: 'cptHcpcsCellHeaderTemplate',
        headerCellRender: cptHcpcsCellHeaderTemplate,
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "cptHcpcsCellTemplate",
        cellRender: cptHcpsTemplate,
        fixed: true,
        alignment: "left",
        width: 180,
      },
      {
        dataField: "procedureModifier1",
        caption: "Mod",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "procedureModifier1CellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "procedureModifier2",
        caption: "Mod",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "procedureModifier2CellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "procedureModifier3",
        caption: "Mod",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "procedureModifier3CellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "procedureModifier4",
        caption: "Mod",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "procedureModifier4CellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "fromServiceDate",
        caption: "Serv Date",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "fromServiceDateCellTemplate",
        fixed: true,
        alignment: "center",
        width: 80,
      },
      {
        dataField: "toServiceDate",
        caption: "Serv Date Thru",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "toServiceDateCellTemplate",
        fixed: true,
        alignment: "center",
        width: 100,
      },
      {
        dataField: "serviceUnits",
        caption: "Units",
        allowFiltering: false,
        allowHeaderFiltering: false,
        cellRender: serviceUnitsTemplate,
        //    cellTemplate: "unitOfMeasurementCellTemplate",
        fixed: true,
        alignment: "center",
        width: 50,
      },
      {
        dataField: "totalChargeAmount",
        caption: "Charges",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "totalChargeAmountCellTemplate",
        fixed: true,
        alignment: "right",
        dataType: "number",
        width: 100,
      },
      {
        dataField: "drg1",
        caption: "Dx1",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "drg1CellTemplate",
        alignment: "center",
        fixed: true,
        width: 45,
      },
      {
        dataField: "drg2",
        caption: "Dx2",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "drg2CellTemplate",
        alignment: "center",
        fixed: true,
        width: 45,
      },
      {
        dataField: "drg3",
        caption: "Dx3",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "drg3CellTemplate",
        alignment: "center",
        fixed: true,
        width: 45,
      },
      {
        dataField: "drg4",
        caption: "Dx4",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "drg4CellTemplate",
        alignment: "center",
        fixed: true,
        width: 45,
      },
      {
        dataField: "placeOfService",
        caption: "POS",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "placeOfServiceCellTemplate",
        alignment: "center",
        width: 70,
      },
      {
        dataField: "originalPaymentAmtDecimal",
        caption: "Original Pmt",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "originalPaymentCellTemplate",
        cellRender: (e) => (
          <div>
            {e.data.originalPaymentAmt != null && (
              <CellComponent>${e.data.originalPaymentAmt} </CellComponent>
            )}
          </div>
        ),
        //fixed: true,
        alignment: "right",
        width: 100,
      },
      {
        dataField: "financialImpact",
        caption: "Fin Impact",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "financialImpactCellTemplate",
        cellRender: (e) => (
          <CellComponent>{e.data.financialImpactAmtForView}</CellComponent>
        ),
        //fixed: true,
        alignment: "center",
        width: 100,
      },
      {
        dataField: "nonCoveredChargedAmt",
        caption: "Non-Covered Chg",
        allowFiltering: false,
        allowHeaderFiltering: false,
        //    cellTemplate: "nonCoveredChargedAmtCellTemplate",
        cellRender: (e) => (
          <div>
            {e.data.nonCoveredChargedAmt != null && (
              <CellComponent>${e.data.nonCoveredChargedAmt} </CellComponent>
            )}
          </div>
        ),
        alignment: "right",
        width: 100,
      },
      {
        dataField: "renderingProvider",
        caption: "Rend Provider",
        allowFiltering: false,
        allowHeaderFiltering: false,
        // cellTemplate: "renderingProviderCellTemplate",
        alignment: "center",
        width: 100,
      },
    ],
  },
};
